module.exports = __webpack_public_path__ + "img/partner_img13.2de5ef9b.png";